import ApiService from './ApiService';

export default class PromotionApi extends ApiService {
    constructor() {
        super('promotion');
    }

    getAllPromotion(payload) {
        return this.get('', payload);
    }

    getDetailPromotion(id) {
        return this.get(`${id}`);
    }

    deletePromotion(id) {
        return this.delete(`${id}`);
    }

    updatePromotion({ id, payload }) {
        return this.put(`${id}`, payload);
    }

    changeStatusPromotion({ id, payload }) {
        return this.put(`promotion-change-status/${id}`, payload);
    }

    postPromotion(payload) {
        return this.post('', payload);
    }

    getAllShopSearchPromotion(payload) {
        return this.get('shops-search-promotion', payload);
    }

    getDataPetOwnerListDetail({ id, payload }) {
        return this.get(`pet-owner-list/${id}`, payload);
    }
}
